// функція сортування по алфафіту
export const sortAlphabetical = (arr, element) => {
    return arr.sort((a, b) => a[element].localeCompare(b[element]));
}